<template>
			
	<v-dialog v-model="dialog" width="600">
				<!-- v-slot:activator="dialog" -->
		<v-card  outlined >
					
			<v-card-title 
				class="justify-center body-2 secondary pa-0" 
				v-text="$ml.get('data')"
			></v-card-title>
				
				<v-card-text>
					<!-- <v-divider></v-divider> -->
						<!-- align="center"  -->
					<v-row
						dense
					>
						<v-col 
							cols = "2"  > <!-- class="pa-1 mt-1 " -->
							<v-card 
								outlined
								class   = "mt-3"

							>
								
								<v-img 
									:src   = "item.thumbnail" 
									@error = "item.thumbnail = '/img/no_img_found.png'"								
									width  = "100%"
									height = "100%"
									contain
									aspect-ratio="1" 
								></v-img>
								<!-- 1.4 -->
							</v-card>
								<!-- style  = "border:white solid 1px" -->
							<!-- class  = "justify-center"  -->
						</v-col>
						<v-col cols = "10">
							<v-simple-table dense>
								<template v-slot:default> 
									<tbody class="ma-0 pa-0" >
										<tr 
											v-for = "(item_show, key_show) of info_show "
											:key  = "key_show"
											class="ma-0 pa-0" 
										>
											<th 
												class="ma-0 pa-0" 
											> {{$ml.get(item_show.text)}} : </th>
											<td
												class="ma-0 pa-0" 
											> {{item[item_show.key]}} </td>
										</tr>
																	
									</tbody>
								</template>
							</v-simple-table>
							<v-divider></v-divider>
						</v-col>
						<v-col
							cols = "12"
						>
							<v-text-field 
								type="text" 
								:label="$ml.get('folder_name')" 
								v-model="name" 
								class="pa-0"
								dense
								outlined
								hide-details
							></v-text-field>
						</v-col>
					</v-row>	
				<!-- </v-card-text> -->
				<v-card-subtitle 
					class="pa-0 my-0 py-0"
					v-text="$ml.get('ms_sel')"
				>
				</v-card-subtitle>
				<v-divider></v-divider>
				 <!-- <v-card-text> -->
					<v-item-group :multiple="true" v-model="select" return-object>
						<v-container fluid class="pa-0">
							<v-row>
								<v-col 
									v-for="n in list" 
									:key="n.id" 
									cols="12"  
									lg="auto" 
									md="auto" 
									sm="1" 
									class="pa-1" 
									style="justify: center;"
									@click = "sel(n)" 
								>
									<v-item v-slot:default="{ active, toggle }">
										<v-card 
											:color = "active ? 'primary' : '' " 
											class  = "pa-0 ma-0" 
											dark  
											style  = "width:60px"  
											@click = "toggle" 
											outlined
										>
										<v-card-title
											class = "pa-0 ma-0 secondary caption "
										>
											<span 												
											>
												{{ n.id }}
											</span>
										</v-card-title>
										  <v-scroll-y-transition>
							                 						                    
												<v-img 
													:src   = "n.thumbnail"
													@error = "n.thumbnail = '/img/no_img_found.png'"
													width  = "100%" 
													height = "100%"
												></v-img>
							                  
							                  
							                  	<!-- <v-img :src="n.thumbnail" width="48" height="64"></v-img> 
															width  = "48" 
													height = "64"
							                  		</div>
							                  	-->
							               
							                </v-scroll-y-transition>
										</v-card>
									</v-item>
								</v-col>
							</v-row>	
						</v-container>
					</v-item-group>
					
			</v-card-text>
			 <v-divider></v-divider>
			 <v-card-actions>
			 	<!-- </div> -->
			 	<!-- <div> -->
			 	<p 
			 		style="line-height: 70%" 
			 		class="pt-1 pb-0"
			 		v-show="show_min"
			 	> {{ $ml.get('minimum_selected') }} {{ min_number }} </p>
			 	<!-- <v-select
			 		v-model   = "select_user"
			 		:items 	  = "list_users"
			 		item-text = "email"
			 		item-key  = "id"
			 		dense
			 		hide-details
			 		outlined
			 	></v-select> -->
		 	    <v-progress-circular
			      indeterminate
			      color="primary"
			      v-show="loading"
			    ></v-progress-circular>
			 	<v-spacer></v-spacer>
			 	<!-- <div> -->
			 		
			 	<v-btn 
			 		small
			 		@click 		= "dialog1 = true" 
			 		v-show 		= "!loading" 
			 		color 		= "primary" 
			 		v-text 		= "$ml.get('to_train')"
			 		:disabled   = "show_min"
			 	></v-btn>
			 	<!-- </div> -->
			 	<v-btn 
			 		small
			 		@click = "dialog = !dialog" 
			 		color  = "error" 
			 		v-text = "$ml.get('close')"
			 	></v-btn>
			 </v-card-actions>
			</v-card>

		<!-- dialog confirm -->
		<v-dialog v-model="dialog1" width="500">
			<v-card>
				<v-card-title 
					v-text="$ml.get('confirm')" 
					class="justify-center"
				></v-card-title>
			<v-card-text>
				<p class="pt-1">{{$ml.get('ms_c')}}</p>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn 
					small 
					color  = "success" 
					v-text = "$ml.get('confirm')"  
					@click = "send"
				></v-btn>
				<v-btn 
					small 
					color  = "error" 
					v-text = "$ml.get('close')"  
					@click = "dialog1 = false"
				></v-btn>
			</v-card-actions>
			</v-card>
		</v-dialog>
	</v-dialog>
		 <!-- <v-snackbar
      v-model="snackbar"
      :color="color"
      right="right"
      :timeout="6000"
      top="top"
    
    >
      {{ msg }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar> -->

		
</template>
<script>
	import axios 	from 'axios';
	import EventBus from '@/event-bus';  
	axios.defaults.withCredentials = false;
	
	export default{
		name: 'show_face',
		props:['info_to_component'],
		data :  ()=>({
			offsetTop: 0,
			select:[],
			show:false,
			dialog:false,
			dialog1:false,
			faces:'',
			list:[],
			name:'',
			item: {},
			info:{
				thumbnail  : '/img/no_img_found.png',
				id_tracker : '',
				timestamp  : ''
			},
			snackbar:false,
			color:'',
			ids:[],
			loading: false,
			min_number: 4,
			show_min: true,
			msg : '',
			list_users : [],
			select_user: '',
			info_show : [
				{
					key  : 'id_tracker',
					text : 'id',
				},
				{
					key : 'timestamp',
					text : 'date',
				},
				{
					key : 'device',
					text : 'device',
				}
			],
			play: false,
			interval_stream: null,
			interval_play: null,
			show_interval: false,
			objectURL: null,

		}),
		
		watch:{ //selected
			info_to_component: function(v){
				// console.log('open modal')
				this.select = [];
				this.name   = ""

				if (v) {					
					this.item   = v; 	
					this.dialog = true;
					this.get_list();
				}
			}, // info to component
			select: function(v){
				let num = 0;
				if (v.length < 4) {
					this.show_min = true;
					// num=this.min_number-1;
					// console.log(v.length, 'length')
  					// this.info=this.$ml.get('minimum_selected') + 4;
  					// this.color="error"
  					// this.snackbar=true

  				}else{
  					this.show_min=false;
  				}
  				// this.min_number=num;

			}, // select

			dialog: function(val){
				if (!val) {
					this.item = this.info;
					this.$emit('close', null);
				}
			}, // dialog
	
		},
		created(){ //localhost
			
			 let test={

            "id_tracker": 123,
            "thumbnail":"http://localhost:8004/media/uploads/tracker/2020-03-19/123/thumbnail/72a28c03-190.jpg",

            "folder_path": "/home/odt/Downloads/facenet/contributed/save_dir/16",
            "timestamp" : 123456789,
            }
           
           	if (localStorage.getItem('list_users')) {
           		this. list_users = JSON.parse(localStorage.getItem('list_users'));
           	}
           // this.list.push(test);
		},
		methods:{
			onScroll (e) {
	    		this.offsetTop = e.target.scrollTop
	  		},
	  		get_list(){
	  			const id  	 = this.item.id_tracker;	  		
	  			this.loading = true;
	  			this.list 	 = [];
	      		const api    = this.$URL_face + '/api/face/logfaces/'+id+'/';
	  			axios.get(api).then(response =>  {
	  				this.list 	 = response.data.results;
	  				this.loading = false;

	  			}).catch( error => { 
	  				console.log("Error get faces : ", error);
	  				this.loading = false;
	  				// this.errors=error
	  			})
				
  			},
  			
  			send(){
  				this.dialog1 = false;
  				if (!this.name) {
  					// this.msg="Missing a name or select thumbnails"
  					// this.color="error"
  					// this.snackbar=true
  					EventBus.$emit('notifications_modal',{
  						type : 'error',
  						message: 'Missing a name or select thumbnails',
  					})
  				}else{
  						//json end
	      			let item = {      				  
	      				'array_id_thumbnail' : this.ids,
						'id_tracker' 		 : this.item.id_tracker,
						'name'  			 : this.name, 		
						'trained_thumbnail'  : this.item.thumbnail,
						'host_id' 			 : this.item.host_id,
						'array_device_id'    : this.item.array_device_id,		
	      			}
	      			
	      			this.loading=true;

	      				//axios send
	  				// axios.defaults.withCredentials=true
	  				const api = this.$URL_face+'/api/face/training/';
	  				axios.post(api, item
	  				).then(response=> {
	  					/*this.msg=response.data;
	  					this.msg="Save";
	  					this.color="success"*/
	  					this.name 	 = ""
	  					// this.snackbar=true;
	  					this.loading = false;
	  					this.dialog  = false;
	  					// this.$emit('close',false);
	  					EventBus.$emit('notifications_modal',{
  							type 	: 'saved',  
  							message : 'Training faces',
  						})

	  				}).catch(error =>{
	  					/*this.msg="No Save";
	  					this.color="error"*/
	  					this.name  	 = ""
	  					// this.snackbar=true;
	  					this.loading = false;
	  					this.dialog  = false;
	  					EventBus.$emit('notifications_modal',{
  							type 	: 'error',  
  							message : 'Not its Training',
  						})
	  					// this.$emit('close',false);
	  				})
  				}
  			},
  			sel(v){
  				if (this.ids.includes(v.id)) {
					this.ids.splice(this.ids.indexOf(v.id) , 1);
  				}else{

  					this.ids.push(v.id);
  				}
  				

      		},
			start_stream(){
				this.$emit('start', true)
			},
			base64ToBlob(base64, contentType) {
				const byteCharacters = atob(base64);
				const byteNumbers = new Array(byteCharacters.length);
				for (let i = 0; i < byteCharacters.length; i++) {
					byteNumbers[i] = byteCharacters.charCodeAt(i);
				}
				const byteArray = new Uint8Array(byteNumbers);
				return new Blob([byteArray], { type: contentType });
			}
		},
		beforeDestroy() {
			if (this.objectURL) {
				URL.revokeObjectURL(this.objectURL);
			}
		},
		mounted(){//id_tracker
			
			

			// http://186.144.34.154:8004/api/face/logfaces/id_tracker/
			const socket = new  WebSocket("ws://" +this.$localhost+':'+this.$port_face+ "/ws/events") //186.144.34.154
			socket.onmessage = function (e) { 
			let data = JSON.parse(e.data);

			let viewer = this.$refs.viewer_face
	      		if (viewer) {
					if (this.objectURL) {
						URL.revokeObjectURL(this.objectURL);
					}
					const blob = this.base64ToBlob(data.photo, 'image/jpeg');
					this.objectURL = URL.createObjectURL(blob);
					viewer.src = this.objectURL;
	      		}
	    	};
		}, // mounted
	}
</script>